module.exports = __webpack_public_path__ + "img/sm_ig.a15b93cf.png";